import { CircularProgress, Container, Grid } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useGetDriverTermsDataQuery } from "@/libs/generated/hooks";
import type { GetDriverTermsDataQueryVariables } from "@/libs/generated/operations";
import type { DriverObject } from "@/libs/generated/types";
import { RoutePaths } from "@/utils/constants/routes";
import DriverForm from "./driver-form-simple";
import DriverTermsState from "./driver-terms-state";
import DriverToolBar from "./toolbar";
import type { TDriverData } from "./types";

type TDriverRequestDetails = {
  showTerms?: boolean;
  driverData: TDriverData;
  actions?: React.ReactNode;
};

function DriverRequestDetails({ showTerms, driverData, actions }: TDriverRequestDetails) {
  const { id } = useParams();
  // const { t } = useTranslation();
  const location = useLocation();

  if (!id) throw new Error("no driver id in params");

  const isWaitingRequest = location.pathname.includes(RoutePaths.waitingRequests);

  // const uniqueId = useId();

  const {
    data: terms,
    error: termsError,
    isLoading: termsLoading,
  } = useGetDriverTermsDataQuery({ driverId: Number(id) } as GetDriverTermsDataQueryVariables, {
    enabled: !isWaitingRequest,
  });

  if (termsLoading) return <CircularProgress />;

  if (termsError && !isWaitingRequest) {
    // return <p>{t("common.error.generic")}</p>;
  }
  // Only validate terms data if not a waiting request
  if (!isWaitingRequest && !terms?.getDriverTermsData) {
    return <p>No driver terms data found</p>;
  }

  return (
    <Container sx={{ py: 4 }} maxWidth="xl">
      <Grid container spacing={2}>
        {driverData.confirmedByAlb && (
          <Grid size={{ xs: 12 }}>
            <DriverToolBar driverData={driverData as DriverObject} />
          </Grid>
        )}

        <DriverForm data={driverData} />

        {showTerms && (
          <Grid container size={{ xs: 12 }} spacing={2}>
            <DriverTermsState termsData={terms?.getDriverTermsData} driverData={driverData} />
          </Grid>
        )}

        {actions && actions}

        {/* <Grid xs={12}>
          <Questions data={driverData.mcqAnswers} />
        </Grid> */}
      </Grid>
    </Container>
  );
}

export default DriverRequestDetails;
